var React = require('react');
var Player = require('./Player');
var Playlist = require('./Playlist');
var PLAY_MODES = require('../../../src/constants/AppConstants').playModes;

var PlayerComponent = React.createClass({
  getInitialState: function() {
    return {
      playlistToggled: true,
    };
  },

  handlePlayNow: function(pos, video){
    if(pos !== this.props.position){
      this.props.setPlaylistChange({position: pos});
      this.props.setVideoPlaying(true);
    } else {
      // clicked on the currently playing video - pause
      this.props.setVideoPlaying(!this.props.playing)
    }
  },

  componentDidUpdate: function(oldProps){
    if(this.props.position !== oldProps.position){
      this.playVideoByPos(this.props.position);
    }
  },

  // --- handlers

  handleVideoEnded: function(){
    var pos = this.getNextSong(),
        pl = this.props.playlist;

    if(pos > -1){
      // next video go!
      if(pos != this.props.position){
        this.setState({video: pl[pos].id});
        this.props.setPlaylistChange({position: pos});
      } else {
        // shitty edge case of restarting a video
        window.dispatchEvent(new CustomEvent('restartVideo'));
      }
    } else {
      // no video, stop
      this.props.setVideoPlaying(false);
    }
  },

  // ----

  getNextSong: function(){
    var nextPos = this.props.position + 1;
    if(nextPos < this.props.playlist.length){
      // go to next video
      return nextPos;
    } else {
      // stop
      return -1;
    }
  },

  playVideoByPos: function(pos){
    if(pos >= 0){
      this.setState({
        video: this.props.playlist[pos],
      });
    }
  },

  videoStarted: function(){
    this.props.setVideoPlaying(true);
  },

  videoStopped: function(){
    this.props.setVideoPlaying(false);
  },

  noop: function(){},

  render: function() {
    var btnToggleClassName = 'playlist-toggle flat ' + (!this.props.position ? 'disabled' : '');
    return (
      <div className="player-container">
        <Player
          video={this.state.video}
          position={this.props.position}
          stopped={this.videoStopped}
          started={this.videoStarted}
          ended={this.handleVideoEnded}
          playerReady={this.props.onPlayerReady}
          playing={this.props.playing}
        />

        <Playlist
          playlist={this.props.playlist}
          position={this.props.position}
          switchPlaylistItems={this.switchPlaylistItems}
          handlePlayNow={this.handlePlayNow}
          playing={this.props.playing}
          />
      </div>
    );
  }

});


module.exports = PlayerComponent;
